/**
 * Angular imports.
 */
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { InfiniteScrollModule } from 'ngx-infinite-scroll';


/**
 * Component imports.
 */
import { GameComponent } from './game.component';
import { NcpCardComponent } from './ncp-card/ncp-card.component';
import { GameCardComponent } from './game-card/game-card.component';
import { GameDetailComponent } from './game-detail/game-detail.component';
import { GameListComponent } from './game-list/game-list.component';
import { LeaderboardComponent } from './leaderboard/leaderboard.component';
import { PlayerComponent } from './leaderboard/player/player.component';
import { GameScreenComponent } from './game-screen/game-screen.component';

/**
 * Module imports.
 */
import { AppHeaderModule } from '../common/header/header.module';
import { GameRoutingModule } from './game-routing.module';
import { CarouselModule } from 'ngx-owl-carousel-o';
import { ProductCommentBoxModule } from './../common/product-comment-box/product-comment-box.module';
import { ProductCommentModule } from './../common/product-comment/product-comment.module';
import { ProductLikeModule } from '../common/product-like/product-like.module';
import { PipesModule } from '../pipes/pipes.module';
import { HealthcardComponent } from './healthcard/healthcard.component';
import { NgxCaptureModule } from 'ngx-capture';
import { AnalyticsEventModule } from '../analytics-event/analytics-event.module';
import { ProductMaskingCardModule } from '../common/product-masking-card/product-masking-card.module';
import { DirectivesModule } from '../directives/directives.module';
import { ShareModule } from '../common/commons.module';


@NgModule({
  imports: [
    CommonModule,
    AppHeaderModule,
    GameRoutingModule,
    CarouselModule,
    ProductCommentBoxModule,
    ProductCommentModule,
    ProductLikeModule,
    PipesModule,
    InfiniteScrollModule,
    NgxCaptureModule,
    AnalyticsEventModule,
    ProductMaskingCardModule,
    DirectivesModule,
    ShareModule
  ],
  declarations: [
    GameComponent,
    GameDetailComponent,
    GameListComponent,
    GameCardComponent,
    LeaderboardComponent,
    PlayerComponent,
    GameScreenComponent,
    NcpCardComponent,
    HealthcardComponent
  ],
  exports: [
    GameCardComponent,
    NcpCardComponent,
    HealthcardComponent
  ]
})
export class GameModule { }
